// Common API's
const GetWorkOrderTypesAndCategories = 'Common/GetWorkOrderTypesAndCategories'
const GetWorkorderStages = 'Common/GetWorkorderStages'
const GetCountryStates = 'Common/GetCountryStates'
const GetDocumentTemplateData = 'Common/GetDocumentTemplateData'
const GetDocumentTemplateByCode = 'Common/GetDocumentTemplateByCode'
const GetOfficeCodes = 'Common/GetOfficeCodes'
const GetDailyActivitiesByCorporationId = "Common/GetDailyActivitiesByCorporationId"
const GetFileDetails = "Common/GetFileDetails"

// Dashboard API's
const GetCustomerWorkorders = 'Dashboard/GetCustomerWorkorders'
const FilterWorkorders = 'Dashboard/FilterWorkorders'
const GetVesselDashboard = 'getVesselDashboard'
const SendFeedbackEmail = 'Dashboard/SendFeedbackEmail'

// Company API's
const GetPartiesOfCurrentUser = 'Company/GetPartiesOfCurrentUser'
const GetPartiesByName = 'Company/GetPartiesByName'
const GetPartiesByPartyId = 'Company/GetPartiesByPartyId'
const RefreshWorkorderEntities = 'RefreshWorkorderEntities'
const ResponsibleOffices = "Company/ResponsibleOffices"

const CreateCompany = 'Company/CreateCompany'
const GetAllCompanies = 'Company/GetAllCompanies'
const ValidateClient = 'Company/ValidateClient'
const ValidateWorkorderCreation = 'ValidateApostillePermission'
const GetCorporationsByPartyId = 'Company/GetCorporationsByPartyId'
// const AgentWorkorderEntities = 'LTC/DL/GetCorporationsByCompanyId'
const AgentWorkorderEntities = 'Company/GetCorporationsByPartyId'
const GetSigners = 'APT/SAPT/GetSigners'

const GetInActiveInvoiceById = 'Common/GetInActiveInvoiceById'
const GetAccountByAgentId = "Common/GetAccountByAgentId"
const GetWorkorderProducts = "GetWorkorderProducts"
const CancelAndReplaceWorkorderInvoice = "CancelAndReplaceWorkorderInvoice"

// Workorders API's
const GetBaseWorkOrderData = 'GetBaseWorkOrderData'
const CreateWorkorder = 'CreateWorkorder'
const UpdateWorkorderData = 'UpdateWorkorderData'
const GetWorkorderById = 'GetWorkorderById'
const UpdateWorkorder = 'UpdateWorkorder'
const RemoveWorkorderDocument = 'FileUpload/RemoveWorkorderDocument'
const RequestMoreInfo = 'RequestMoreInfo'
const GetInvoiceDocument = 'GetInvoiceDocument'
const UpdateNeedMoreInfoStatus = 'UpdateNeedMoreInfoStatus'
const CancelWorkorder = 'CancelWorkorder'
const ArchivedWorkorder = 'ArchivedWorkorder'
const RejectWorkorder = 'RejectWorkorder'
const ResendDocusignEmail = 'ResendDocusignEmail'
const GetAuthorizationDocument = 'GetAuthorizationDocument'
const ValidateVesselDetails = 'ValidateVesselDetails'
const GetWorkOrderFilesByFileId = 'FileUpload/GetWorkOrderFilesByFileId'
const GetVesselOwnersData = 'GetVesselOwnersData'
const GetVendorsData = 'GetVendorsData'
const GetBillableVoyAges = 'GetBillableVoyAges'
const GetUpdatedBillableVoyages = 'GetUpdatedBillableVoyages'
const GetCompanyAddressdetails = 'GetCompanyAddressdetails'
const GetAllProducts = 'GetAllProducts'
const GetCurrentQBbyCompany = 'GetCurrentQBbyCompany'
const GetERBPCListByIMONumber = 'GetERBPCListByIMONumber'
const GetPreviewDocument = 'PreviewAuthorizationDocument'
const GetPartyDetailsByPartyId = "Company/GetPartyDetailsByPartyId"
// Workorder Comments Api's
const GetWorkorderComments = 'WorkorderComment/GetWorkorderComments'
const CreateComment = 'WorkorderComment/CreateComment'

// API's
const GetAllVesselsByAccountId = 'GetAllVesselsByAccountId'
const GetVesselByIMONumber = 'GetVesselByIMONumber'
const GetSoftwareVersionPClist = 'GetSoftwareVersionPClist'
const ResendEmails = 'ResendEmail'
const UpdateBillingPrefix = 'UpdateBillingPrefix'
const CancelWorkorderInvoice = "CancelWorkorderInvoice"
const UpdateResendEmail = 'ResendEmail'
const GetAgreementDocument = 'GetAgreementDocument'
const PreviewAgreementDocument = 'PreviewAgreementDocument'
const RegenarateAuthorizationLetter = 'RegenarateAuthorizationLetter'
const RegenerateAuthorizationLetter = 'RegenerateDocument'
const ResendADDocument = 'ResendAnnualDeclaration'
const ResendDLDocument = 'ResendDeclarationLetter'
const ResendActivity = "ResendActivity"
//RLM
const GetListFiles = "GetListFiles"
const GetAllActiveVaultsForUser = "GetActiveVaultsForUser"
const DownloadFile = "DownloadFile"
const GetCompanyAddress = "Company/GetCompanyAddress"
const GetLastModifiedFiles = "GetLastModifiedFiles"
const GetCorporationsByNameOrId = "Company/GetCorporationsByNameOrId"
const GetDashBoardData = "Dashboard/GetDashBoardData"
const GetCorporationsByEntityIdOrName = "Company/GetCorporationsById"
const GetFileContentByFileReferenceNumber = "GetFileContentByFileReferenceNumber"
const SendApostilEmail = "SendApostilEmail"
const UpdateFileName = "UpdateFileName"
const GetSpecimenSignatureFile = "GetSpecimenSignatureFile"
const GetAgentsApostillePermission = "GetAgentsApostillePermission"
const UpdateApostillePermission = "CreateOrUpdateApostillePermission"
const CreateApostillePermission = "CreateOrUpdateApostillePermission"
const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'

export const ApiUrls = {
  GetInActiveInvoiceById,
  GetAccountByAgentId,
  GetWorkorderProducts,
  CancelAndReplaceWorkorderInvoice,
  GetWorkOrderTypesAndCategories,
  UpdateApostillePermission,
  CreateApostillePermission,
  GetWorkorderStages,
  GetCountryStates,
  GetDocumentTemplateData,
  GetFileDetails,
  GetCustomerWorkorders,
  FilterWorkorders,
  GetVesselDashboard,
  SendFeedbackEmail,
  ValidateClient,
  GetPartiesByName,
  GetPartiesByPartyId,
  CreateCompany,
  ValidateWorkorderCreation,
  UpdateFileName,
  GetBaseWorkOrderData,
  CreateWorkorder,
  UpdateWorkorderData,
  GetWorkorderById,
  UpdateWorkorder,
  RemoveWorkorderDocument,
  RequestMoreInfo,
  GetInvoiceDocument,
  UpdateNeedMoreInfoStatus,
  CancelWorkorder,
  ArchivedWorkorder,
  GetPartyDetailsByPartyId,
  RejectWorkorder,
  ResendDocusignEmail,
  ValidateVesselDetails,
  GetWorkOrderFilesByFileId,
  GetVesselOwnersData,
  GetVendorsData,
  GetBillableVoyAges,
  GetUpdatedBillableVoyages,
  GetCompanyAddressdetails,
  GetAllProducts,
  GetCurrentQBbyCompany,
  GetWorkorderComments,
  CreateComment,
  GetAgreementDocument,
  PreviewAgreementDocument,
  GetAuthorizationDocument,
  GetAllVesselsByAccountId,
  GetVesselByIMONumber,
  ResendEmails,
  UpdateBillingPrefix,
  CancelWorkorderInvoice,
  UpdateResendEmail,
  RegenarateAuthorizationLetter,
  GetERBPCListByIMONumber,
  GetSoftwareVersionPClist,
  GetListFiles,
  GetAllActiveVaultsForUser,
  DownloadFile,
  GetCompanyAddress,
  GetLastModifiedFiles,
  GetCorporationsByPartyId,
  AgentWorkorderEntities,
  GetDocumentTemplateByCode,
  GetAllCompanies,
  GetPartiesOfCurrentUser,
  RegenerateAuthorizationLetter,
  ResendADDocument,
  ResendDLDocument,
  ResendActivity,
  RefreshWorkorderEntities,
  GetPreviewDocument,
  GetCorporationsByEntityIdOrName,
  GetCorporationsByNameOrId,
  GetDashBoardData,
  GetSigners,
  GetOfficeCodes,
  GetFileContentByFileReferenceNumber,
  SendApostilEmail,
  GetDailyActivitiesByCorporationId,
  ResponsibleOffices,
  GetSpecimenSignatureFile,
  GetAgentsApostillePermission,
  GetUsers,
  GetUserRoles,
  SaveUserRoles
}